
export {SelectAll,
SelectAllCommand,
SelectAllEditing,
SelectAllUI} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-select-all$dist$index.js.js';
